import React from 'react'
import { Box,CircularProgress } from '@mui/material'

function CommonLoader() {
  return (
    <Box sx={{ width: '100vw', height: "100vh", display:"flex", justifyContent:"center", alignItems:"center" }}>
<CircularProgress size="lg" sx={{width:"80px", height:"80px"}} />
</Box> 
  )
}

export default CommonLoader